import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { IconButton, Typography, Box as MuiBox, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import CustomTableItems from '../customTableItems/CustomTableItems';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import { Person } from '@mui/icons-material';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  fontsize:'23px',
  borderRadius: '6px',
};

export default function CustomModalItems(props: { data: any, openModal: boolean, deleteData: any, isSearch: boolean, handleFunction: any, setItemPedido: any, editavel?: boolean, ordemDigitacao?: number, camposSelecionados?: string | null, temTabPreco: boolean }) {
  const [open, setOpen] = React.useState(props.openModal);
  const handleOpen = () => {
    if (props.camposSelecionados) {
      // Se for a mensagem específica, passa o ícone Person
      if (props.camposSelecionados === "Selecione o agente") {
        mostraMensagemErro(props.camposSelecionados, <Person sx={{ fontSize: 20 }} />);
      } else {
        mostraMensagemErro(props.camposSelecionados);
      }
      return;
    }
    setOpen(true);
    // props.handleFunction()
  }
  const handleClose = () => setOpen(false);

  const showOnTable = ['codItem', 'descricao', 'valor', 'codUnidade', 'percIpi'];

  const validateValues = (data: any[], keys: string[]) => {
    return data.map((item) => {
      const validatedItem: any = { ...item };
      keys.forEach((key) => {
        validatedItem[key] = item[key] !== undefined ? item[key] : '-';
      });

      return validatedItem;
    });
  };

  return (
    <div>
      {!props.isSearch &&
        <Button
          className='fields'
          variant="contained"
          onClick={handleOpen}
          sx={{ maxWidth: 130, minWidth: 130, height: 30, backgroundColor: '#0965c1', color: '#fff', textTransform: 'none' }}
          disabled={!props.editavel}
        >
          Adicionar item
        </Button>
      }
      {props.isSearch &&
        <IconButton
          aria-label="delete"
          sx={{ marginTop: 2, backgroundColor: '#5693B9', color: '#fff' }}
          onClick={handleOpen}
        >
          <SearchIcon />
        </IconButton>
      }
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 0,
              marginTop: -2
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ShoppingCartIcon sx={{ fontSize: 20, color: '#0965c1' }} />
              <Typography id="modal-modal-title" variant="subtitle1" component="h2" fontSize='16px' color='#334155'>
                Buscar item
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: '#0965c1',
                '&:hover': {
                  color: 'gray',
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ width: '100%', marginBottom: 2.2, marginTop: -0.4 }} />
          <CustomTableItems data={validateValues(props.data, showOnTable)} handleSetItemPedido={props.setItemPedido} isPedido={false} search={true} ordemDigitacao={props.ordemDigitacao} temTabPreco={props.temTabPreco}/>
        </Box>
      </Modal>
    </div>
  );
}